

const liveUserReg = () => import('../views/pages/other/live-user-reg.vue');
const liveAuth = () => import('../views/pages/other/live-auth.vue');
const otherRouter = [
    {
        path: '/live-user-reg', name: 'live-user-reg', component: liveUserReg, meta: { requireAuth: false },
    },
    {
        path: '/live-auth', name: 'live-auth', component: liveAuth, meta: { requireAuth: false },
    },
]


export {
    otherRouter,
}; 
